const arr = [
    {
      id: 1,
      title: "Home",
      cName: "nav_link",
    },
    {
      id: 2,
      title: "About",
      cName: "nav_link",
    },
    {
      id: 3,
      title: "Events",
      cName: "nav_link",
    },
    {
      id: 4,
      title: "Membership",
      cName: "nav_link",
    },
    {
      id: 5,
      title: "Team",
      cName: "nav_link",
    },
    {
      id: 6,
      title: "Contact",
      cName: "nav_link",
    }
  ];
  
  export default arr;